import { HMF_Text } from "../../Atoms/Text/Text.component";
import S from "./TextImage.module.scss";

interface TextImageProps {
    headline: string;
    description: { markup: string };
    image?: { url: string };
}

const TextImage = ({ headline, description, image }: TextImageProps) => (
    <div>
        <h2>{headline}</h2>
        <div className={S.text}>{description && <HMF_Text html={description?.markup} />}</div>
        {image && <img src={image.url} alt={headline} />}
    </div>
);

export default TextImage;
